import { useMutation } from '@tanstack/react-query';

import { API_VERSION_V2 } from '~/constants';
import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category Logout */
export type TypeLogoutResponse = {
  /** 계정 코드 */
  laborAccountId: number;
  /** 근무한 시간 */
  workingHour: number;
  /** 근무한 분 */
  workingMinute: number;
  /** 로그아웃 시각 */
  logoutDateTime: string;
};

/**
 * @description 로그아웃 api 요청에 사용되는 커스텀 훅
 * @returns
 */
export const useLogout = () => {
  const { mutateAsync } = useMutation({
    mutationFn: () => {
      const endpoint = '/labor-account/logout';
      return axiosInstance.post(endpoint, null, { headers: { version: API_VERSION_V2 } });
    },
  });

  const requestLogout = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (res: TypeLogoutResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(), onSuccess, onError);
  };

  return requestLogout;
};
